import React, { Component } from 'react';
// import * as api from './../../api'

export default class Popup extends Component {
  constructor(props) {
    super (props)
    this.state = {
      awardsDom: null,
      gameResult: {}
    }
  }

  componentWillMount() {
    let result = JSON.parse(sessionStorage.getItem('yqs_gameScore'))
    this.setState({gameResult: result})
  }
  // <li>
  //   <span className='icon coin'></span>
  //   <span>x</span>
  //   <span>{gameResult.fruit}</span>
  // </li>
  render() {
    // let { gameResult } = this.state
    let result = JSON.parse(sessionStorage.getItem('yqs_gameScore'))
    return (
      <div>
        <p className='great'>你击败全国<span className='rate'>{this.props.rateVal||'75.62%'}</span>的用户，获得</p>
        <ul className='awardList'>
          <li>
            <span className='icon redBag'></span>
            <span>×</span>
            <span>{result.red_pocket}</span>
          </li>
          <li>
            <span className='icon coin'></span>
            <span>×</span>
            <span>{result.coin}</span>
          </li>
        </ul>
      </div>
    )
  }
}